<template lang="pug">
  b-row.mb-5
    b-col
      link-networks-form(:action='action')
</template>

<script>
import LinkNetworksForm from '@views/container/manager/globals/contacts/link_networks/Form'

export default {
  name: 'manager-contacts-link_networks-new',
  components: {
    LinkNetworksForm,
  },
  props: {
    action: String,
  },
}
</script>
